var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "256px",
    height: "256px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#454b54",
    d: "M89,52.3c0,13.8-11.2,25-25,25s-25-11.2-25-25L89,52.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64 37.3A50 15 0 1 0 64 67.3A50 15 0 1 0 64 37.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#98bed8",
    d: "M34.3,50.9c2.1,4.7,14.6,8.7,29.7,8.7c15.3,0,28-3,29.8-8.7C92,45.2,79.3,42.2,64,42.2 C48.9,42.2,36.4,46.2,34.3,50.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#454b54",
    d: "M64,70.3c-26.3,0-53-6.2-53-18c0-11.8,26.7-18,53-18c26.3,0,53,6.2,53,18C117,64.1,90.3,70.3,64,70.3 M64,40.3c-33,0-47,8.6-47,12c0,3.4,14,12,47,12c33,0,47-8.6,47-12C111,48.9,97,40.3,64,40.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d8e3eb",
    d: "M34.32,50.944C36.445,55.727,48.898,59.7,64,59.7c15.104,0,27.56-2.898,29.681-8.468 C91.5,56.717,78.999,59.6,64,59.6C48.948,59.6,36.479,55.625,34.32,50.944 M64,40.3c-12.355,0-22.048,1.206-29.339,2.893 C34.228,45.225,34,47.336,34,49.5c0,0.472,0.102,0.939,0.3,1.399C36.401,46.2,48.901,42.2,64,42.2 c15.292,0,27.988,2.997,29.797,8.691C93.931,50.444,94,49.98,94,49.5c0-2.164-0.228-4.275-0.661-6.308 C86.048,41.506,76.355,40.3,64,40.3 M64,19.5c-11.999,0-22.326,7-27.129,17.151C45.139,35.093,54.595,34.3,64,34.3 c9.405,0,18.86,0.793,27.128,2.351C86.326,26.5,75.999,19.5,64,19.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9d0df",
    d: "M64,42.2c-15.099,0-27.599,4-29.7,8.699c0.006,0.015,0.013,0.03,0.02,0.045 C36.479,55.625,48.948,59.6,64,59.6c14.999,0,27.5-2.884,29.681-8.368c0.043-0.112,0.082-0.226,0.116-0.341 C91.988,45.197,79.292,42.2,64,42.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0adb8",
    d: "M64,34.3c-9.405,0-18.861,0.793-27.129,2.351c-0.975,2.061-1.723,4.253-2.211,6.541 C41.952,41.506,51.645,40.3,64,40.3s22.048,1.206,29.339,2.893c-0.487-2.289-1.235-4.48-2.211-6.541 C82.86,35.093,73.405,34.3,64,34.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#454b54",
    d: "M84.5,60.3c-1.3,0-2.5-0.9-2.9-2.2c-0.5-1.6,0.4-3.3,2-3.7c4.5-1.3,7.3-3.2,7.3-4.9s1.3-3,3-3 s3,1.3,3,3c0,3.3-2,7.9-11.6,10.7C85.1,60.2,84.8,60.3,84.5,60.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.2,49.4c-0.2,0-0.3,0-0.5,0c-1.6-0.3-2.8-1.8-2.5-3.4C43,34.9,52.8,26.5,64,26.5c1.7,0,3,1.3,3,3 s-1.3,3-3,3c-8.3,0-15.5,6.2-16.8,14.4C47,48.4,45.7,49.4,44.2,49.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#454b54",
    d: "M94 52.5c-1.7 0-3-1.3-3-3 0-14.9-12.1-27-27-27s-27 12.1-27 27c0 1.7-1.3 3-3 3s-3-1.3-3-3c0-18.2 14.8-33 33-33s33 14.8 33 33C97 51.1 95.7 52.5 94 52.5zM42.7 108.7c-.3 0-.5 0-.8-.1-1.6-.4-2.5-2.1-2.1-3.7l8.5-31.2c.4-1.6 2.1-2.5 3.7-2.1 1.6.4 2.5 2.1 2.1 3.7l-8.5 31.2C45.3 107.8 44.1 108.7 42.7 108.7zM85.3 108.7c-1.3 0-2.5-.9-2.9-2.2l-8.5-31.2c-.4-1.6.5-3.2 2.1-3.7 1.6-.4 3.2.5 3.7 2.1l8.5 31.2c.4 1.6-.5 3.2-2.1 3.7C85.8 108.6 85.5 108.7 85.3 108.7zM64 91.7c-1.7 0-3-1.3-3-3V77.3c0-1.7 1.3-3 3-3 1.7 0 3 1.3 3 3v11.3C67 90.3 65.7 91.7 64 91.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUfo);
export default __webpack_public_path__ + "static/media/ufo.3f6c484b57de75315488a02619690745.svg";
export { ForwardRef as ReactComponent };